import { render, staticRenderFns } from "./FedExMfaOptionStep.vue?vue&type=template&id=3872a82c&scoped=true"
import script from "./FedExMfaOptionStep.vue?vue&type=script&lang=ts"
export * from "./FedExMfaOptionStep.vue?vue&type=script&lang=ts"
import style0 from "./FedExMfaOptionStep.vue?vue&type=style&index=0&id=3872a82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3872a82c",
  null
  
)

export default component.exports